import PropTypes from "prop-types"
import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import Container from "../container"
import * as variable from "../variables"
import BackgroundImage from "gatsby-background-image"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import ThemeContext from "../../context/ThemeContext"
import MobileMenu from "../mobilemenu"

const HeaderStyle = styled.header`
  padding: 0px 0px;
  width: 100%;
  position: fixed;
  z-index: 100;
  background-color: white;
  .header-menu-logo {
    display: flex;
    justify-content: space-between;
    height: 135px;
    align-items: center;
    .logo {
      max-width: 320px;
      flex-grow: 1;
    }
    .main-menu {
      padding: 0px;
      margin: 0px;
      display: flex;
      width: calc(100% - 335px);
      justify-content: flex-end;
      > li {
        list-style: none;
        margin-right: 60px;
        display: flex;
        align-items: center;
        position: relative;
        &:last-child {
          margin-right: 0px;
          a {
            background-color: #a3013c;
            border-radius: 50px 50px 50px 50px;
            padding: 12px 30px 12px 30px;
            color: white;
            font-size: 16px;
          }
        }
        &.icons {
          margin-right: 10px;
        }
        a {
          color: ${variable.gray};
          text-decoration: none;
          font-size: 18px;
          font-display: fallback;
          font-weight: 400;
          display: flex;
          align-items: center;
        }
        &:hover > ul {
          visibility: visible;
          opacity: 1;
          display: block;
          transition-duration: 0.5s;
        }
        ul {
          visibility: hidden;
          opacity: 0;
          position: absolute;
          transition: all 0.5s ease;
          margin-top: 30px;
          left: -15px;
          top: 0;
          display: none;
          z-index: 999999999999999;
          padding: 15px;
          width: 200px;
          li {
            background-color: rgba(255, 255, 255, 1);
            margin: 0px;
            padding: 10px 10px;
            border-bottom: thin solid ${variable.black};
            list-style: none;
            a {
              color: ${variable.black};
              font-size: 14px;
            }
          }
          &:hover {
            visibility: visible;
            opacity: 1;
            display: block;
          }
        }
      }
    }
  }
  @media (max-width: ${variable.tabletWidth}) {
    .header-menu-logo {
      .logo {
        max-width: 190px;
      }
      .main-menu {
        width: calc(100% - 210px);
        display: none;
        li {
          margin-right: 15px;
          a {
            font-size: 14px;
          }
        }
      }
    }
  }
  @media (max-width: ${variable.mobileWidth}) {
    .header-menu-logo {
      .main-menu {
        display: none;
      }
    }
  }
  .header-top{
    background-color:rgba(239,239,239,0.76);
    padding:20px 0px;
    .header-top-container{
      display:flex;
      justify-content:space-between;
      @media (max-width: ${variable.mobileWidth}) {
        flex-direction:column;
        align-items:center;
      }
      a{
        display:block;
        color:#0338a0;
        border:2px solid #0338a0;
        padding:10px 20px;
        &:hover{
          background-color:#0338a0;
          color:white;
        }
        &:nth-child(2){
          @media (max-width: ${variable.mobileWidth}) {
            margin-top:20px;
          }
        }
        &:nth-child(3){
          display:none;
          @media (max-width: ${variable.mobileWidth}) {
            background-color: #a3013c;
            border-radius: 50px 50px 50px 50px;
            padding: 12px 30px 12px 30px;
            color: white;
            font-size: 16px;
            margin-top:20px;
            display:block;
          }
        }
      }
    }
  }
`

export const Header = ({ mainmenu }) => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo_new.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const logo = data.logo.childImageSharp.fluid

  return (
    <HeaderStyle className="kcch-header">
      <div className="header-top">
      <Container className="header-top-container">
        <a href="mailto:info@kansascitycorporatehousing.com">info@kansascitycorporatehousing.com</a>
        <a href="tel:844-816-1218">(844) 816-1218</a>
        <a href="/get-started-kansas-city-corporate-housing">Get Started</a>
        </Container>
      </div>
      <div className="header-bg">
        <Container className="header-menu-logo">
          <Link className="logo" to="/">
            <Img fluid={logo} />
          </Link>
          <ul className="main-menu">
            {mainmenu.map((menuitem, index) => (
              <li key={index}>
                <Link to={menuitem.link}>{menuitem.name}</Link>
                {menuitem.submenu && (
                  <ul className="sub-menu">
                    {menuitem.submenu.map((submenuitem, index) => (
                      <li key={index}>
                        <Link to={submenuitem.link}>{submenuitem.name}</Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
          <MobileMenu></MobileMenu>
        </Container>
      </div>
    </HeaderStyle>
  )
}

export default Header
